export class NamirasoftFieldCookieHeader 
{
    VERSION()
    {
        return "ns-field-version";
    }
}